import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import type { SxProps, Theme } from '@mui/material';
import { type CheckboxProps } from '@mui/material/Checkbox';

interface NumberedCheckboxProps extends Omit<CheckboxProps, 'icon' | 'checkedIcon'> {
  label: number;
}

const checkboxSize = 18;

const BaseIcon = ({ children, ...additionalStyles }: { children?: React.ReactNode } & SxProps<Theme>) => (
  <Box
    sx={{
      width: checkboxSize,
      height: checkboxSize,
      border: '2px solid',
      borderColor: (theme) => theme.palette.primary.main,
      borderRadius: 1,
      ...additionalStyles,
    }}
  >
    {children}
  </Box>
);

const UncheckedIcon = () => <BaseIcon />;

const CheckedIcon = ({ children }: { children: React.ReactNode }) => (
  <BaseIcon backgroundColor={(theme) => theme.palette.primary.main} display="flex" alignItems="center" justifyContent="center">
    <Typography
      variant="body2"
      color="primary.contrastText"
      sx={{
        fontWeight: 600,
      }}
    >
      {children}
    </Typography>
  </BaseIcon>
);

export function NumberedCheckbox({ label, ...checkboxProps }: NumberedCheckboxProps) {
  return <Checkbox {...checkboxProps} icon={<UncheckedIcon />} checkedIcon={<CheckedIcon>{label}</CheckedIcon>} disableRipple />;
}
